function isEqual(a,s){return baseIsEqual(a,s)}var baseIsEqual=require("./_baseIsEqual");module.exports=isEqual;